import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from 'src/app/_service/shared.service';
import { UserService } from 'src/app/_service/user.service';

@Component({
  selector: 'app-lead-histories',
  templateUrl: './lead-histories.component.html',
  styleUrls: ['./lead-histories.component.css']
})
export class LeadHistoriesComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('circleSearch') circleSearchElement: ElementRef;
  @ViewChild('usersSearch') usersSearchElement: ElementRef;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  perpage:number=25;leadHistories:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;circles=[];circle='';search:string;currentUserId:any;circles_copy=[];status='';booleanValue: any = false;
  users=[];users_copy=[];user='';start_date:string='';end_date:string=''
  constructor(private leadService: LeadsService, private sharedapi: SharedService, private userService: UserService) { }

  ngOnInit(): void {
    this.getcircle();

    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
  }
  ngAfterViewInit() {
    this.getLeadHistories(0,this.perpage);
  }
  async getLeadHistories(pageIndex,perpage)
  {
    this.getUsers();
    this.paginator.pageIndex = pageIndex;
    this.loading = true;this.loaded = false;
    let qString = 'circle='+this.circle+'&user='+this.user+'&date_range='+this.start_date+'-'+this.end_date;
    await this.leadService.getLeadHistories(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if(data.status){
        this.leadHistories = data.data;
      }else{
        this.leadHistories = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
  })
  }

  async getcircle()
  {
      await this.leadService.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
              this.circles_copy = this.circles;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getUsers()
  {
    let requestData = {
      "roles" : ['2','3'],
      "circle" : this.circle
    }
    this.userService.getUserByRolesAndCircle(requestData).subscribe((data:any) => {
      if(data.status)
          {
              this.users = data.data;
              this.users_copy = this.users;
          }else{
              this.users = [];
              this.users_copy = this.users;
          }
    }, error => {
      this.sharedapi.checkError(error);
    })
  }
  setSearchValue(type){
      if(type=='circle'){
        this.circles= this.circles_copy;
        this.circleSearchElement.nativeElement.focus();
        this.circleSearchElement.nativeElement.value = '';
      } else if(type=='users'){
        this.users = this.users_copy;
        this.usersSearchElement.nativeElement.focus();
        this.usersSearchElement.nativeElement.value = '';
      }
  }

  searchOnSelect(searchtText: string, type){
    if(type == 'circle'){
        this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if(type == 'users'){
      this.users = this.sharedapi.searchData(searchtText, this.users_copy, "name");
    }
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.getLeadHistories(event.pageIndex,event.pageSize);
  }

  dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.getLeadHistories(0,this.perpage);
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.getLeadHistories(0,this.perpage);
    }


}
